import React, { useState, useEffect } from "react";
import { firestore, collection, getDocs, doc, updateDoc, setDoc, getDoc } from '../config/firebaseConfig';
import { CiEdit } from "react-icons/ci";
import { RiCalendarScheduleLine } from "react-icons/ri";
import { FaCircle } from "react-icons/fa";

const statusMapping = {
  true: { icon: <FaCircle style={{ color: "#2e8b57", fontSize: "20px" }} />, tooltip: "Ligado" },
  false: { icon: <FaCircle style={{ color: "#E27070", fontSize: "20px" }} />, tooltip: "Desligado" }
};

const Agendamentos = () => {
  const [agendamentos, setAgendamentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const minicursoId = 'minicursos_diario';

  useEffect(() => {
    const fetchAgendamentos = async () => {
      setLoading(true);
      const agendamentosCollection = collection(firestore, "agendamentos");
      const agendamentosSnapshot = await getDocs(agendamentosCollection);
      
      const agendamentosList = agendamentosSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        isEditing: false,
      }));
      
      const sortedList = agendamentosList.sort((a, b) => {
        if (a.id === minicursoId) return 1;
        if (b.id === minicursoId) return -1;
        return 0;
      });
      
      setAgendamentos(sortedList);
      setLoading(false);
    };

    fetchAgendamentos();
  }, []);

  const handleCreateMinicursoSchedule = async () => {
    const tenantId = localStorage.getItem('tenantId');
    if (!tenantId) {
      alert("Tenant ID não encontrado.");
      return;
    }
    const agendamentoRef = doc(firestore, "agendamentos", minicursoId);
    const agendamentoData = {
      nome: 'Minicursos',
      tenantId: tenantId,
      horario: '08:00',
      frequencia: 'Diariamente',
      status: true,
      dia: "",
      intervaloHoras: 24,
    };
    try {
      await setDoc(agendamentoRef, agendamentoData);
      window.location.reload(); 
    } catch (error) {
      console.error("Erro ao criar agendamento de minicurso:", error);
      alert("Erro ao criar agendamento de minicursos.");
    }
  };

  const handleEditClick = (agendamentoId) => {
    setAgendamentos((prevAgendamentos) =>
      prevAgendamentos.map((agendamento) =>
        agendamento.id === agendamentoId
          ? { ...agendamento, isEditing: true }
          : { ...agendamento, isEditing: false }
      )
    );
  };

  const handleUpdate = async (e, agendamentoId) => {
    e.preventDefault();
    const tenantId = localStorage.getItem('tenantId');
    const agendamento = agendamentos.find((a) => a.id === agendamentoId);

    if (agendamento) {
      const docRef = doc(firestore, "agendamentos", agendamentoId);
      try {
        const updates = {
          horario: agendamento.horario,
          status: agendamento.status,
        };

        if (agendamento.id !== minicursoId) {
          updates.frequencia = agendamento.frequencia;
          updates.dia = agendamento.frequencia === 'Semanal' ? agendamento.dia : "";
        } else {
          updates.intervaloHoras = 24; 
        }
        
        await updateDoc(docRef, updates);
        
        setAgendamentos((prevAgendamentos) =>
          prevAgendamentos.map((a) =>
            a.id === agendamentoId ? { ...a, isEditing: false } : a
          )
        );
      } catch (error) {
        console.error("Erro ao atualizar agendamento: ", error);
        alert("Erro ao atualizar agendamento.");
      }
    }
  };

  const handleChange = (e, agendamentoId, field) => {
    const value = e.target.value;
    setAgendamentos((prevAgendamentos) =>
      prevAgendamentos.map((agendamento) =>
        agendamento.id === agendamentoId ? { ...agendamento, [field]: value } : agendamento
      )
    );
  };

  const toggleStatus = async (agendamentoId, currentStatus) => {
    const newStatus = !currentStatus;
    const docRef = doc(firestore, "agendamentos", agendamentoId);

    try {
      await updateDoc(docRef, { status: newStatus });
      setAgendamentos((prevAgendamentos) =>
        prevAgendamentos.map((agendamento) =>
          agendamento.id === agendamentoId ? { ...agendamento, status: newStatus } : agendamento
        )
      );
    } catch (error) {
      console.error("Erro ao alternar o status: ", error);
      alert("Erro ao alternar o status.");
    }
  };

  if (loading) {
    return <p>Carregando...</p>;
  }

  const minicurso = agendamentos.find(a => a.id === minicursoId);

  return (
    <div className="agendamentos-container">
      <div className="agendamentos-header">
        <RiCalendarScheduleLine size="30" />
        <p>Agendamentos</p>
      </div>      
      <div className="agendamentos-list">
        {agendamentos.map((agendamento) => (
          <div key={agendamento.id} className="agendamento-item">
            {agendamento.isEditing ? (
              <form onSubmit={(e) => handleUpdate(e, agendamento.id)} className="agendamento-form" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <strong>{agendamento.nome}</strong>

                {agendamento.id !== minicursoId && (
                  <>
                    <select
                      value={agendamento.frequencia || ""}
                      onChange={(e) => handleChange(e, agendamento.id, "frequencia")}
                    >
                      <option value="">Frequência</option>
                      <option value="Diariamente">Diariamente</option>                  
                      <option value="Semanal">Semanal</option>
                      <option value="Segunda-a-sexta">Segunda a Sexta</option>
                    </select>

                    {agendamento.frequencia === "Semanal" && (
                      <select
                        value={agendamento.dia || ""}
                        onChange={(e) => handleChange(e, agendamento.id, "dia")}
                      >
                        <option value="Domingo">Domingo</option>
                        <option value="Segunda">Segunda-feira</option>
                        <option value="Terça">Terça-feira</option>
                        <option value="Quarta">Quarta-feira</option>
                        <option value="Quinta">Quinta-feira</option>
                        <option value="Sexta">Sexta-feira</option>
                        <option value="Sábado">Sábado</option>
                      </select>
                    )}
                  </>
                )}

                <input
                  type="time"
                  value={agendamento.horario}
                  onChange={(e) => handleChange(e, agendamento.id, "horario")}
                  required
                />
                
                <button type="submit">OK</button>
              </form>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <p>
                  <strong>{agendamento.nome}</strong> {agendamento.horario}
                  {agendamento.id !== minicursoId &&
                    ` (${agendamento.frequencia}${(agendamento.frequencia === "Semanal") ? ' ' + agendamento.dia : ""})`}
                  {agendamento.id === minicursoId &&
                    ` (A cada 24h)`}
                </p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <CiEdit onClick={() => handleEditClick(agendamento.id)} style={{ cursor: 'pointer' }} />
                  <div onClick={() => toggleStatus(agendamento.id, agendamento.status)} style={{ cursor: 'pointer' }}>
                    {statusMapping[agendamento.status] && statusMapping[agendamento.status].icon}
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
        {!minicurso && (
          <div className="agendamento-item" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
            <p style={{ marginBottom: '10px' }}>
              Nenhum agendamento para minicursos encontrado.
            </p>
            <button onClick={handleCreateMinicursoSchedule}>
              Criar Agendamento de Minicursos
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Agendamentos;